export default __webpack_public_path__ + "media/images/gallery/14-8fa275596719ecfe6759ee71d85ac715.jpg";